import { Directive, ElementRef, HostListener, Input, Pipe, PipeTransform, Renderer, Renderer2 } from '@angular/core';
import { MatGridTileHeaderCssMatStyler, MatSnackBar, MatSnackBarConfig } from '@angular/material';

@Directive({
  selector: '[onHoverDescribe]'
})
export class OnHoverDescribeDirective {

  @Input()
  onHoverDescribe:any;

  constructor(private el: ElementRef,private renderer: Renderer, private matSnackBar: MatSnackBar) {}

  @HostListener('mouseover') onMouseOver() { 
    this.openSnackBar(this.onHoverDescribe)
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.duration = 5000;
    this.matSnackBar.open(message,null,config);
  }
}
